"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3728],{

/***/ 92145:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ny": function() { return /* binding */ EFinderImageSizes; },
  "yK": function() { return /* binding */ OptimizeEFinderImage; },
  "ZP": function() { return /* binding */ common_EFinderImage; }
});

// EXTERNAL MODULE: ./.yarn/__virtual__/@emotion-react-virtual-7a26ef4a22/0/cache/@emotion-react-npm-11.11.1-a07d6a6ebd-aec3c36650.zip/node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(8683);
// EXTERNAL MODULE: ./.yarn/__virtual__/@emotion-react-virtual-7a26ef4a22/0/cache/@emotion-react-npm-11.11.1-a07d6a6ebd-aec3c36650.zip/node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(11717);
// EXTERNAL MODULE: ./.yarn/__virtual__/next-virtual-9251101693/0/cache/next-npm-12.3.4-cdaf2db0a7-d96fc4f5bc.zip/node_modules/next/image.js
var next_image = __webpack_require__(26410);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/index.js
var react = __webpack_require__(39953);
// EXTERNAL MODULE: ./.yarn/__virtual__/chatie-design-system-virtual-6d39449242/0/cache/chatie-design-system-https-edc3b42f07-dc9424d6a3.zip/node_modules/chatie-design-system/dist/esm/index.js + 10 modules
var esm = __webpack_require__(9150);
;// CONCATENATED MODULE: ./utils/efinderImage.ts
var SIGNED_URL_QUERY_KEYS = [
    "Expires",
    "Signature",
    "Key-Pair-Id",
    "Policy", 
];
var isCloudFrontSignedUrl = function(url) {
    try {
        var searchParams = new URL(url).searchParams;
        return SIGNED_URL_QUERY_KEYS.some(function(key) {
            return searchParams.has(key);
        });
    } catch (e) {
        return false;
    }
};
var resolveEFinderImageSource = function(param) {
    var url = param.url, contentType = param.contentType, requestedHeight = param.requestedHeight, attachmentHeight = param.attachmentHeight;
    if (contentType === "image/gif" || requestedHeight === undefined || isCloudFrontSignedUrl(url)) {
        return url;
    }
    var height = attachmentHeight ? Math.min(requestedHeight, attachmentHeight) : requestedHeight;
    var separator = url.includes("?") ? "&" : "?";
    return "".concat(url).concat(separator, "t=h&d=").concat(height);
};

;// CONCATENATED MODULE: ./components/common/EFinderImage.tsx
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  0% {\n    opacity: 0;\n  }\n\n  100% {\n    opacity: 1;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n    border-radius: ",
        ";\n  "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  animation: ",
        " 0.5s linear forwards;\n  overflow: hidden;\n  border-radius: inherit;\n  ",
        "\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  position: relative;\n  width: 100%;\n  height: 100%;\n  overflow: hidden;\n  background: ",
        ";\n\n  &[data-state='loading'] img,\n  &[data-state='error'] img {\n    opacity: 0;\n  }\n\n  .image-state {\n    position: absolute;\n    inset: 0;\n    z-index: 1;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    padding: ",
        "px;\n    color: ",
        ";\n    text-align: center;\n    font-size: ",
        "px;\n    line-height: 1.35;\n    background: ",
        ";\n  }\n\n  .image-state[data-loading='true']::after {\n    width: 28px;\n    height: 28px;\n    border: 3px solid ",
        ";\n    border-top-color: ",
        ";\n    border-radius: 50%;\n    content: '';\n    animation: efinder-image-spin 1s linear infinite;\n  }\n\n  @keyframes efinder-image-spin {\n    to {\n      transform: rotate(360deg);\n    }\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}






var fadeInKeyframes = (0,emotion_react_browser_esm.keyframes)(_templateObject());
var imageCSS = function(radius) {
    return (0,emotion_react_browser_esm.css)(_templateObject2(), fadeInKeyframes, radius && (0,emotion_react_browser_esm.css)(_templateObject1(), typeof radius === "string" ? radius : "".concat(radius, "px")));
};
var imageFrameCSS = function(theme) {
    return (0,emotion_react_browser_esm.css)(_templateObject3(), theme.var.gray100, esm/* Spacing.xsmall */.Ki.xsmall, theme.var.gray400, esm/* FontSizes.xsmall */.TS.xsmall, theme.var.gray100, theme.colors.main100, theme.colors.main500);
};
var ratio = 2;
var EFinderImage = function(_param) {
    var className = _param.className, image = _param.image, h = _param.h, radius = _param.radius, width = _param.width, height = _param.height, alt = _param.alt, objectFit = _param.objectFit, objectPosition = _param.objectPosition, loading = _param.loading, layout = _param.layout, priority = _param.priority, _showLoadingState = _param.showLoadingState, showLoadingState = _showLoadingState === void 0 ? false : _showLoadingState, _fallbackText = _param.fallbackText, fallbackText = _fallbackText === void 0 ? "이미지를 불러오지 못했어요" : _fallbackText, rest = _objectWithoutProperties(_param, [
        "className",
        "image",
        "h",
        "radius",
        "width",
        "height",
        "alt",
        "objectFit",
        "objectPosition",
        "loading",
        "layout",
        "priority",
        "showLoadingState",
        "fallbackText"
    ]);
    var attachment = image === null || image === void 0 ? void 0 : image.attachment;
    var bgUrl = attachment ? resolveEFinderImageSource({
        url: attachment.url,
        contentType: attachment.contentType,
        requestedHeight: h === undefined ? undefined : h * ratio,
        attachmentHeight: attachment.height
    }) : "";
    var ref = _slicedToArray(react.useState("loading"), 2), loadState = ref[0], setLoadState = ref[1];
    react.useEffect(function() {
        setLoadState("loading");
    }, [
        bgUrl
    ]);
    if (!attachment) {
        return null;
    }
    var renderedImage = /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)((image_default()), _objectSpreadProps(_objectSpread({
        css: imageCSS(radius),
        className: className
    }, rest), {
        src: bgUrl,
        width: width,
        height: height,
        layout: layout || "fill",
        loading: loading || (priority ? "eager" : "lazy"),
        objectFit: objectFit || "cover",
        alt: alt,
        objectPosition: objectPosition || "center",
        unoptimized: true,
        priority: !!priority,
        onLoadingComplete: function() {
            return setLoadState("loaded");
        },
        onError: function() {
            return setLoadState("error");
        }
    }));
    if (!showLoadingState) {
        return renderedImage;
    }
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("div", {
        css: imageFrameCSS,
        "data-state": loadState,
        "aria-busy": loadState === "loading",
        children: [
            renderedImage,
            loadState === "loading" && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("span", {
                className: "image-state",
                "data-loading": "true",
                "aria-label": "이미지 로딩 중"
            }),
            loadState === "error" && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("span", {
                className: "image-state",
                children: fallbackText
            })
        ]
    });
};
var OptimizeEFinderImage = function(_param) {
    var className = _param.className, image = _param.image, h = _param.h, radius = _param.radius, width = _param.width, height = _param.height, alt = _param.alt, objectFit = _param.objectFit, objectPosition = _param.objectPosition, loading = _param.loading, layout = _param.layout, priority = _param.priority, rest = _objectWithoutProperties(_param, [
        "className",
        "image",
        "h",
        "radius",
        "width",
        "height",
        "alt",
        "objectFit",
        "objectPosition",
        "loading",
        "layout",
        "priority"
    ]);
    if (!image || !image.attachment) {
        return null;
    }
    var _attachment = image.attachment, url = _attachment.url, contentType = _attachment.contentType, attachmentHeight = _attachment.height;
    var myLoader = function(param) {
        var src = param.src, _quality = param.quality, quality = _quality === void 0 ? 75 : _quality;
        return "".concat(src, "&q=").concat(quality);
    };
    var bgUrl = resolveEFinderImageSource({
        url: url,
        contentType: contentType,
        requestedHeight: h === undefined ? undefined : h * ratio,
        attachmentHeight: attachmentHeight
    });
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)((image_default()), _objectSpreadProps(_objectSpread({
        css: imageCSS(radius),
        className: className
    }, rest), {
        src: bgUrl,
        width: width,
        height: height,
        loader: myLoader,
        layout: layout || "fill",
        loading: loading || (priority ? "eager" : "lazy"),
        objectFit: objectFit || "cover",
        alt: alt,
        objectPosition: objectPosition || "center",
        priority: !!priority
    }));
};
/* harmony default export */ var common_EFinderImage = (EFinderImage);
var EFinderImageSizes;
(function(EFinderImageSizes) {
    EFinderImageSizes[EFinderImageSizes["marketItem"] = 80] = "marketItem";
    EFinderImageSizes[EFinderImageSizes["banner"] = 420] = "banner";
    EFinderImageSizes[EFinderImageSizes["playBanner"] = 280] = "playBanner";
    EFinderImageSizes[EFinderImageSizes["avatar"] = 64] = "avatar";
    EFinderImageSizes[EFinderImageSizes["chatbot"] = 150] = "chatbot";
})(EFinderImageSizes || (EFinderImageSizes = {}));


/***/ }),

/***/ 26382:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(8683);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(11717);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(83289);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(39953);
/* harmony import */ var _stores_useThemeStore__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(34946);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(45432);
/* harmony import */ var _contexts_global__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(30259);
/* harmony import */ var _styles_css__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(96964);
/* harmony import */ var _Push__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(23516);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n    position: relative;\n    max-width: ",
        "px;\n    margin: 0 auto;\n    background-color: ",
        ";\n    min-height: 100%;\n\n    color: ",
        ";\n\n    ",
        " {\n      max-width: ",
        "px;\n    }\n\n    ",
        " {\n      max-width: ",
        "px;\n    }\n\n    @media all and (min-width: ",
        "px) {\n      box-shadow: 0 0 10px ",
        "cc;\n    }\n\n    .has-sidebar & {\n      ",
        " {\n        max-width: none;\n        margin: 0;\n        box-shadow: none;\n      }\n    }\n  "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  position: relative;\n  min-height: 100%;\n\n  color: ",
        ";\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n                @media all and (min-width: ",
        "px) {\n                  html {\n                    background-color: ",
        ";\n                  }\n                }\n              "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n                html {\n                  background-color: ",
        " !important;\n                }\n              "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}









var pcLayoutCSS = function(backgroundColor) {
    return function(theme) {
        return (0,_emotion_react__WEBPACK_IMPORTED_MODULE_7__.css)(_templateObject(), _styles_css__WEBPACK_IMPORTED_MODULE_5__/* .MAX_WIDTH */ .d, backgroundColor !== null && backgroundColor !== void 0 ? backgroundColor : theme.var.white, theme.var.black, _styles_css__WEBPACK_IMPORTED_MODULE_5__/* .media.tablet */ .BC.tablet, _styles_css__WEBPACK_IMPORTED_MODULE_5__/* .BREAKPOINTS.tablet */ .j$.tablet, _styles_css__WEBPACK_IMPORTED_MODULE_5__/* .media.desktop */ .BC.desktop, _styles_css__WEBPACK_IMPORTED_MODULE_5__/* .BREAKPOINTS.desktop */ .j$.desktop, _styles_css__WEBPACK_IMPORTED_MODULE_5__/* .BREAKPOINTS.desktop */ .j$.desktop + 1, theme.var.gray200, _styles_css__WEBPACK_IMPORTED_MODULE_5__/* .media.tablet */ .BC.tablet);
    };
};
var mobileLayoutCSS = function(theme) {
    return (0,_emotion_react__WEBPACK_IMPORTED_MODULE_7__.css)(_templateObject1(), theme.var.black);
};
var Layout = function(param) {
    var className = param.className, theme = param.theme, backgroundColor = param.backgroundColor, children = param.children, isSSR = param.isSSR, isPush = param.isPush;
    var platform = (0,_contexts_global__WEBPACK_IMPORTED_MODULE_4__/* .useGlobalContext */ .bN)().platform;
    var setTheme = (0,_stores_useThemeStore__WEBPACK_IMPORTED_MODULE_2__/* .useThemeStore */ .f)().setTheme;
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (isSSR) {
            return;
        }
        // theme prop이 명시적으로 전달된 경우에만 override
        if (theme) {
            setTheme(theme);
        } else {
            // localStorage에 저장된 테마가 없을 때만 __darkMode__ 사용
            var stored = localStorage.getItem("theme");
            if (!stored) {
                setTheme(window.__darkMode__ ? "dark" : "light");
            }
        }
    }, [
        theme,
        isSSR
    ]);
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsxs)("div", {
        className: className,
        suppressHydrationWarning: true,
        css: platform === _constants__WEBPACK_IMPORTED_MODULE_3__/* .Platform.web */ .t4.web ? pcLayoutCSS(backgroundColor) : mobileLayoutCSS,
        children: [
            backgroundColor && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)((next_head__WEBPACK_IMPORTED_MODULE_0___default()), {
                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)("meta", {
                    name: "theme-color",
                    content: backgroundColor
                })
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(_emotion_react__WEBPACK_IMPORTED_MODULE_7__.Global, {
                styles: function(theme) {
                    return platform === _constants__WEBPACK_IMPORTED_MODULE_3__/* .Platform.web */ .t4.web ? (0,_emotion_react__WEBPACK_IMPORTED_MODULE_7__.css)(_templateObject2(), _styles_css__WEBPACK_IMPORTED_MODULE_5__/* .BREAKPOINTS.desktop */ .j$.desktop + 1, theme.var.gray100) : (0,_emotion_react__WEBPACK_IMPORTED_MODULE_7__.css)(_templateObject3(), backgroundColor !== null && backgroundColor !== void 0 ? backgroundColor : theme.var.white);
                }
            }),
            children,
            isPush && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(_Push__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                size: _Push__WEBPACK_IMPORTED_MODULE_6__/* .PushSize.bottomTab */ .z.bottomTab,
                bottom: true
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Layout);


/***/ }),

/***/ 23516:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "z": function() { return /* binding */ PushSize; }
/* harmony export */ });
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(8683);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(11717);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(39953);
/* harmony import */ var chatie_design_system__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9150);
/* harmony import */ var _styles_css__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(96964);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  box-sizing: content-box;\n  ",
        ";\n  ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}





var pushCSS = function(isTopSafeArea, isBottomSafeArea) {
    return (0,_emotion_react__WEBPACK_IMPORTED_MODULE_3__.css)(_templateObject(), isTopSafeArea && (0,_styles_css__WEBPACK_IMPORTED_MODULE_2__/* .safeArea */ .BI)("top"), isBottomSafeArea && (0,_styles_css__WEBPACK_IMPORTED_MODULE_2__/* .safeArea */ .BI)("bottom", "padding", chatie_design_system__WEBPACK_IMPORTED_MODULE_1__/* .Spacing.medium */ .Ki.medium));
};
var Push = function(param, ref) {
    var _top = param.top, top = _top === void 0 ? false : _top, _bottom = param.bottom, bottom = _bottom === void 0 ? false : _bottom, size = param.size;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("div", {
        ref: ref,
        css: pushCSS(top, bottom),
        style: {
            height: size
        }
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (/*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(Push));
var PushSize;
(function(PushSize) {
    PushSize[PushSize["safe"] = 0] = "safe";
    PushSize[PushSize["header"] = 44] = "header";
    PushSize[PushSize["bottomButton"] = 64] = "bottomButton";
    PushSize[PushSize["bottomTab"] = 56] = "bottomTab";
    PushSize[PushSize["commentForm"] = 70] = "commentForm";
    PushSize[PushSize["tab"] = 43] = "tab";
    PushSize[PushSize["floatingButton"] = 72] = "floatingButton";
})(PushSize || (PushSize = {}));


/***/ }),

/***/ 45861:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(8683);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11717);
/* harmony import */ var chatie_design_system__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9150);
/* harmony import */ var _styles_css__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(96964);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  position: relative;\n  max-width: inherit;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}




var safeareaCSS = (0,_emotion_react__WEBPACK_IMPORTED_MODULE_2__.css)(_templateObject());
var SafeArea = function(param) {
    var className = param.className, top = param.top, bottom = param.bottom, children = param.children;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("div", {
        className: className,
        css: [
            safeareaCSS,
            top ? (0,_styles_css__WEBPACK_IMPORTED_MODULE_1__/* .safeArea */ .BI)("top") : undefined,
            bottom ? (0,_styles_css__WEBPACK_IMPORTED_MODULE_1__/* .safeArea */ .BI)("bottom", "padding", chatie_design_system__WEBPACK_IMPORTED_MODULE_0__/* .Spacing.medium */ .Ki.medium) : undefined, 
        ],
        children: children
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (SafeArea);


/***/ }),

/***/ 65583:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(8683);
/* harmony import */ var react_query__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(54909);
/* harmony import */ var _api_common__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(98379);
/* harmony import */ var _components_common_Banner__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6913);




var CurationBanner = function(param) {
    var sectionId = param.sectionId;
    var data = (0,react_query__WEBPACK_IMPORTED_MODULE_0__.useQuery)([
        "sectionBanner",
        sectionId
    ], function() {
        return (0,_api_common__WEBPACK_IMPORTED_MODULE_1__/* .fetchSectionBanners */ .dE)(sectionId);
    }).data;
    if (!data) {
        return null;
    }
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_components_common_Banner__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP, {
        name: "section-banner",
        size: _components_common_Banner__WEBPACK_IMPORTED_MODULE_2__/* .BannerSize.curation */ .Kj.curation,
        items: data
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (CurationBanner);


/***/ }),

/***/ 38464:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "s": function() { return /* binding */ useMounted; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(39953);

var useMounted = function() {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false), mounted = ref[0], setMounted = ref[1];
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        setMounted(true);
    }, []);
    return mounted;
};


/***/ })

}]);